export default __webpack_public_path__ + "static/media/mail-pc.46364b89.webp";